<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { interactionMixin } from 'src/modules/interactions_module.js';
import StripeHeader from "stripe-header";

export default {
  mixins: [fandomBasicMixin, interactionMixin],
  components: {
    StripeHeader
  },
  data: function () {
    return {
      filters: {
        month: null,
        year: null
      },
      years: [],
      months: {},
      disclaimerItem: null
    };
  },
  mounted: function () {
    this.content.table.forEach(item => {
      if (item.date_column) {
        const d = new Date(item.date_column);
        let year = d.getFullYear();
        let month = d.getMonth();
        month = month < 9 ? `0${month + 1}` : `${month + 1}`;
        this.years.push(year);
        if (!this.months[year]) {
          this.months[year] = [month];
        } else {
          this.months[year].push(month);
        }
      }
    });
    this.years = [...new Set(this.years)];
    this.years.forEach((year) => {
      this.months[year] = [...new Set(this.months[year])];
    });
    this.filters.year = Math.max(...this.years);

    $(this.$refs['disclaimerModal']).on('hidden.bs.modal', () => {
      this.disclaimerItem = null;
    });
  },
  computed: {
    columnsMap() {
      let columnsMap = [false, false, false, false];
      this.content.table.forEach((item) => {
        columnsMap[0] = columnsMap[0] || Fandom.exists(item.text_column_1);
        columnsMap[1] = columnsMap[1] || Fandom.exists(item.text_column_2);
        columnsMap[2] = columnsMap[2] || Fandom.exists(item.text_column_3);
        columnsMap[3] = columnsMap[3] || Fandom.exists(item.text_column_4);
        columnsMap[4] = columnsMap[4] || Fandom.exists(item.attachment_column);
        columnsMap[5] = columnsMap[5] || Fandom.exists(item.date_column);
      });
      return columnsMap;
    },
    isInPageWithSidebar() {
      return this.containerContent.layout == "page-with-sidebar";
    },
    items() {
      let items = this.content.table;
      items = items.filter((item) => {
        if (item.date_column) {
          const d = new Date(item.date_column);
          let response = (d.getFullYear() == this.filters.year) || !this.filters.year;
          if (this.filters.month) {
            let month = d.getMonth();
            month = month < 9 ? `0${month + 1}` : `${month + 1}`;
            response = response && (month == this.filters.month);
          }
          return response;
        } else {
          return true;
        }
      });
      return items;
    },
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : Fandom.retrieveFromGlobalState("one_col_text_width", 8);
      return [
        `col-lg-${columnWidth}`
      ];
    }
  },
  methods: {
    attachmentClickHandler(item) {
      this.disclaimerItem = item;
      $(this.$refs['disclaimerModal']).modal('show');
    },
    openDisclaimerItem() {
      const url = this.disclaimerItem?.attachment_column?.url;

      if (url) {
        window.open(url, '_blank');
        $(this.$refs['disclaimerModal']).modal('hide');
      }
    },
    checkItemVisible(item) {
      return item.text_column_1 || item.text_column_2 || item.text_column_3 || item.text_column_4;
    },
    formattedDate(date) {
      const fDate = new Date(date);
      const month = fDate.getMonth() < 9 ? `0${fDate.getMonth() + 1}` : `${fDate.getMonth() + 1}`;
      const day = fDate.getDate() < 10 ? `0${fDate.getDate()}` : `${fDate.getDate()}`;
      return `${fDate.getFullYear()}/${month}/${day}`;
    },
    getMonthLiteral(number) {
      const months = {
        "it": ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
        "en": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      };
      return months[globalState.lang][parseInt(number) - 1];
    }
  },
  watch: {
    'filters.year': function() {
      this.filters.month = "";
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" v-if="isContentVisibleToUser()" :class="contentType" class="py-4" :style="{'background-color': content.background_color}" table-simple-component>
    <div class="container">
      <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
      <div class="row justify-content-center">
        <div :class="columnClasses">
          <stripe-header :content="content" align="left" class="px-0" col="12"></stripe-header> 
          <form class="form-inline my-3 justify-content-between" v-if="content.table[0] && content.table[0].date_column">
            {{ft("globals.filter_by")}}
            <div class="d-flex align-items-center">
              <div class="form-group mr-5">
                <label :for="`month-select-${contentId}`" class="mr-3">{{ft("globals.month")}}</label>
                <select class="form-control custom-select" :id="`month-select-${contentId}`" v-model="filters.month">
                  <option value="" selected>{{ft("globals.all")}}</option>
                  <option v-for="month in months[filters.year]" :value="month">{{getMonthLiteral(month)}}</option>
                </select>
              </div>
              <div class="form-group">
                <label class="mr-3" :for="`year-select-${contentId}`">{{ft("globals.year")}}</label>
                <select class="form-control custom-select" :id="`year-select-${contentId}`" v-model="filters.year">
                  <option :value="null" selected>{{ft("globals.all")}}</option>
                  <option v-for="year in years">{{year}}</option>
                </select>
              </div>
            </div>
          </form>
          <div class="table-responsive">
            <table class="table table-bordered" >
          	  <tbody>
          	    <tr v-for="item in items" v-if="checkItemVisible(item)">
                  <td v-if="columnsMap[5]" class="p-4 cell date">
                    {{formattedDate(item.date_column)}}
                  </td>
          	      <td v-if="columnsMap[0]" class="p-4 cell" v-html="item.text_column_1"></td>
          	      <td v-if="columnsMap[1]" class="p-4 cell" v-html="item.text_column_2"></td>
          	      <td v-if="columnsMap[2]" class="p-4 cell" v-html="item.text_column_3"></td>
                  <td v-if="columnsMap[3]" class="p-4 cell" v-html="item.text_column_4"></td>
          	      <td v-if="columnsMap[4]" align="middle" class="p-4 attachment-column cell">
                    <template v-if="item.attachment_column">
                      <span v-if="item.attachment_disclaimer" class="cursor-pointer text-dark" @click="attachmentClickHandler(item)">
                        <i class="fal fa-download"></i>
                      </span>
                      <a v-else :href="item.attachment_column.url" target="_blank" class="cursor-pointer text-dark">
                        <i class="fal fa-download"></i>
                      </a>
                    </template>
          	      </td>
          	    </tr>
          	  </tbody>
          	</table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" ref="disclaimerModal" tabindex="-1">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div v-if="disclaimerItem" class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">{{disclaimerItem.attachment_disclaimer.title}}</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i aria-hidden="true" class="fa-regular fa-xmark"></i>
            </button>
          </div>
          <div class="modal-body">
            <div v-html="disclaimerItem.attachment_disclaimer.description"></div>
            <div class="d-flex flex-column flex-sm-row justify-content-between mt-3">
              <button type="button" class="btn btn-dark mb-2 mb-sm-0" data-dismiss="modal">
                {{this.ft('globals.no_accept')}}
              </button>
              <button type="button" class="btn btn-primary" @click="openDisclaimerItem()">
                {{this.ft('globals.accept')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[table-simple-component] { 

  .cell {
    vertical-align: middle;
    font-size: $h5-font-size;

    &.date {
      width: 8rem;
    }
  }

  .attachment-column {
    width: 4rem;
  }

  .custom-select {
    height: 2rem;
    border-radius: 0;
    padding: .25rem 4rem .25rem 3rem;
    font-size: 1rem;

    @include media-breakpoint-only(md) {
      padding: .25rem 4rem .25rem 1rem;
    }
    
    @include media-breakpoint-down(sm) {
      background-position: 90% 50%;
      padding-right: 0rem;
    }
  }


}
</style>